<template>
  <div class="standard-page v-flex">
    <b-button-toolbar
      class="button-toolbar"
      aria-label="Toolbar with button groups"
    >
      <b-button @click="createAccount"><BIcon icon="cash" /> Create</b-button>
    </b-button-toolbar>
    <Table
      class="standard-page-table"
      :fields="tableHeaders"
      :items="accounts"
      :busy="isBusy"
      :totalItems="totalAccounts"
      :totalPages="totalPages"
      :pageSize="pageSize"
      :currentPage="currentPage"
      @pageSizeChanged="handlePageSize"
      @pageChanged="handlePage"
    />
  </div>
</template>

<script>
import Table from '@/components/Table/Table.vue'
// import mockData from './mock-data.js'
import { BIcon } from 'bootstrap-vue'
import endpoints from '@/utils/endpoints.js'
import tableMixins from '@/mixins/TableMixins/tableMixins.js'

export default {
  mixins: [tableMixins],
  components: {
    Table,
    BIcon
  },
  data() {
    return {
      tableHeaders: [
        {
          link: true,
          key: 'id',
          label: 'ID'
        },
        {
          key: 'external_id',
          label: 'External ID'
        },
        'amount_due',
        /* TODO-? Merchant doesn't exist, replace with customer */
        /* {
          key: 'merchant',
          label: 'Merchant',
          formatter: (value, item) => {
            const merchantName = this.getMerchantName(item)
            return merchantName
          },
        }, */
        'due_date',
        'minimum_payment',
        'maximum_payment'
      ],
      accounts: [],
      isBusy: true,
      totalAccounts: null,
      pageSize: 10,
      currentPage: 1,
      totalPages: null
    }
  },
  mounted() {
    this.getAccounts()
    this.$store.dispatch('setPageTitle', { pageTitle: 'Accounts' })
  },
  methods: {
    createAccount() {
      this.$router.push({ name: 'AccountCreate' })
    },
    getAccounts() {
      this.axios
        .get(endpoints.listAccounts(this.$route.params.merchantID), {
          params: { page: this.currentPage, page_size: this.pageSize }
        })
        .then(res => {
          this.accounts = res.data.results
          this.isBusy = false
          this.totalAccounts = res.data.count
          this.totalPages = Math.ceil(this.totalAccounts / this.pageSize)
        })
        .catch(err => {
          console.log('error', err)
        })
    },
    // getMerchantName(item) {
    //   this.axios.get(endpoints.retrieveMerchantOrganization(item.id))
    //   .then(res => {
    //     return res.data.name
    //   })
    // },
    handlePageSize(pageSize) {
      this.handlePageSizeChange(pageSize)
      this.getAccounts()
    },
    handlePage(newPage) {
      this.handlePageChange(newPage)
      this.getAccounts()
    }
  }
}
</script>
